import { render } from "./Comment.vue?vue&type=template&id=743f25d0"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"
script.render = render

export default script